module.exports = __webpack_public_path__ + "media/country_flags/my-f13d036c.png";